import React, { useEffect, useState } from "react";
import { Config } from "../../types";
import './passkey.css';


type MessageEnvelope = {
  subject: "id.myob.com/passkey-enroll";
  message: PublicKeyCredentialCreationOptionsJSON;
  token: string;
  userId: string;
}

export function PasskeyEnrollRoute(config: Readonly<Config>) {
  const [token, setToken] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  
  const PARENT_ORIGIN_DOMAIN = `https://${config.currentEnv === 'prod' ? '' : 'sit.'}myaccount.myob.com`
  
  const handleCreatePasskey = async () => {
    try {
      const response = await fetch(`https://${config.domain}/me/v1/authentication-methods`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ "type": "passkey", "connection": "myob-idam", "identity_user_id": userId }),
      })

      const data = await response.json();

      const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(data.authn_params_public_key);

      const credential = await navigator.credentials.create({
        publicKey,
      });

      const payload = (credential as PublicKeyCredential).toJSON();

      const body = { 
        "auth_session": data.auth_session, 
        "authn_response": {
            "authenticatorAttachment": payload.authenticatorAttachment,
            "id": payload.id,
            "rawId": payload.rawId,
            "type": payload.type,
            "response": {
              "clientDataJSON": payload.response.clientDataJSON,
              "attestationObject": payload.response.attestationObject
            },
        }
      }

      const resp = await fetch(`https://${config.domain}/me/v1/authentication-methods/passkey|new/verify`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (resp.status === 201) {
        window.parent.postMessage(
          {
            type: "PASSKEY_ENROLL_SUCCESS",
            userId: userId,
          },
          PARENT_ORIGIN_DOMAIN
        );
      }
    } catch (err) {
      console.error('error creating credential', err);
      window.parent.postMessage(
        {
          type: "PASSKEY_ENROLL_ERROR",
          userId: userId,
        },
        PARENT_ORIGIN_DOMAIN
      );
    }
  }

  const handleCancelClick = () => {
    window.parent.postMessage(
      {
        type: "PASSKEY_ENROLL_CANCEL",
        userId: userId,
      },
      PARENT_ORIGIN_DOMAIN
    );
  }

  useEffect(() => {
    document.body.classList.add('passkey-enroll-page');
    return () => {
      document.body.classList.remove('passkey-enroll-page');
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleMessage = async (event: MessageEvent<MessageEnvelope>) => {
      if (event.data.subject !== "id.myob.com/passkey-enroll") {
        return;
      }

      if (event.origin !== globalThis.location.origin && event.origin !== PARENT_ORIGIN_DOMAIN) {
        console.error(`Invalid origin: ${event.origin}, expected ${global.location.origin}`);
        return;
      }

      if (event.data.token == null || event.data.userId == null) {
        console.error(`Invalid message data: ${JSON.stringify(event.data)}`);
        return;
      }

      try {
        setToken(event.data.token);
        setUserId(event.data.userId);
      } catch (err) {
        console.error('error handling message: ', err);
        window.parent.postMessage(
          {
            type: "PASSKEY_ENROLL_INIT_ERROR",
            error: (err as Error).message || String(err),
          },
          PARENT_ORIGIN_DOMAIN
        );
      }
    };

    window.addEventListener("message", handleMessage);
    window.parent.postMessage(
      {
        type: "PASSKEY_ENROLL_READY"
      },
      PARENT_ORIGIN_DOMAIN
    );
    return () => window.removeEventListener("message", handleMessage);
  }, [PARENT_ORIGIN_DOMAIN]);

  return (
    <div className="_1OsuE _owGd _28eJk _2qhIa _2T4WITuK2 flx-btn-row flx-btn-row__primary-group bg" data-flx-comp="ButtonRow" data-flx-version="7.3.8" style={{ display: token && userId ? 'block' : 'none' }}>
      <div className="_1OsuE _owGd _28eJk _3uu__ _2hynz _2hA0r _2tGaa flx-col flx-col--2 _1dBOOTuK2 _10x6n _33kT7 _1WMu8 _2RsrE" data-flx-comp="ButtonRow.Columns" data-flx-version="7.3.8">
        <div className="_1OsuE _owGd _3y-QMTuK2 _2tj5oTuK2 _357HiTuK2 _4brUy RzISo _2cECE _2UxP4 _3iU2W _3qMRv" data-flx-comp="ButtonRow.Column" data-flx-version="7.3.8">
          <button id="cancel-passkey-button" className="_1OsuE _owGd PaXsB _1doLG _3uu__ _3TxRs _1v2JD _1cSKz _8AGGZTuK2 _2zBRE _1oC5STuK2 _237uwTuK2 _1JsL9TuK2 Dw6pcTuK2 _3HAdyTuK2 _2rheUTuK2 _2DxNDTuK2 _1YJUC _13WvZTuK2 G73BBTuK2 btn btn-primary _2Vt4tTuK2" data-flx-comp="Button" data-flx-version="7.3.8" type="button" onClick={handleCancelClick}>
            <div className="_1OsuE _owGd btn__container _1dsA7TuK2 _2X4CgTuK2">
              <span className="btn__content _14zpR _22FgnTuK2">Cancel</span>
            </div>
          </button>
        </div>
        <div className="_1OsuE _owGd _3y-QMTuK2 _2tj5oTuK2 _357HiTuK2 _4brUy RzISo _2cECE _2UxP4 _3iU2W _3qMRv" data-flx-comp="ButtonRow.Column" data-flx-version="7.3.8">
          <button id="add-passkey-button" className="_1OsuE _owGd PaXsB _1doLG _3uu__ _3TxRs _1v2JD _1cSKz _8AGGZTuK2 _2zBRE _1oC5STuK2 xvY6dTuK2 _1JsL9TuK2 _2loisTuK2 _3HAdyTuK2 _2rheUTuK2 _2DxNDTuK2 _1YJUC _2ZvPRTuK2 G73BBTuK2 btn btn-primary _2Vt4tTuK2" data-flx-comp="Button" data-flx-version="7.3.8" type="button" onClick={handleCreatePasskey}>
            <div className="_1OsuE _owGd btn__container _1dsA7TuK2 _2X4CgTuK2">
              <span className="btn__content _14zpR _22FgnTuK2">Add passkey</span>
            </div>
          </button>
        </div>
      </div>
    </div>)
}